import { useWatch } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { FieldSkeleton } from '@/components/layout/field-row'
import { Typography } from '@/components/ui/typography'

import { PlaceFeatureGroup, PlaceFlags } from '../../features/places-features.constants'
import { collectPlaceFeatureKeys, getPlaceFeatureTree } from './place-feature-tree'

const getGroupsKeys = (groups: readonly PlaceFeatureGroup[]) =>
  groups
    .map((group) => collectPlaceFeatureKeys(getPlaceFeatureTree(group)))
    .filter((keys) => keys.length > 0)

export const PlaceFeaturesOverview = ({ groups }: { groups: readonly PlaceFeatureGroup[] }) => {
  const { t } = useTranslation(['organisation'])
  const values = useWatch<PlaceFlags>()
  const groupsKeys = getGroupsKeys(groups)
  const keys = groupsKeys.flat()

  return (
    <Typography size="text-medium" color="primary600" as="p">
      {t('organisation:places.features.summary.overview', {
        enabled: keys.filter((key) => values[key]).length,
        groups: groupsKeys.length,
        total: keys.length,
      })}
    </Typography>
  )
}

// Note: the size of the loaded line, so nothing jumps when the building arrives
export const PlaceFeaturesOverviewSkeleton = () => <FieldSkeleton height="2rem" width="28rem" />
